import styles from "../../styles/_sections/_mainAttractionDetail/schedule.module.scss";

const Schedule = () => {
  return (
    <div className={styles.container}>
      <h2>Hours of operation of the complex</h2>

      <div className={styles.days}>
        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Sunday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Monday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Tuesday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Wednesday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Thursday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Friday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>

        <div className={styles.day}>
          <div className={styles.name}>
            <input type="text" value="Saturday" />
          </div>

          <div className={styles.hours}>
            <input type="text" value="09:00" />
            <input type="text" value="09:00" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
